export default __webpack_public_path__ + "static/media/bg_2.c98d58ae.webp";